import { Modal } from "antd"
import React, { useImperativeHandle, useState } from "react"
import componentStyles from "./AntdModal.module.css"

export default function AntdModal({
   children,
   footer,
   title,
   passedInRef,
   width,
   className,
   style,
   contentStyle,
   bodyStyle,
   maskStyle,
   preventCloseWhen = false,
}) {
   // LOCAL STATE
   const [isOpen, setIsOpen] = useState(false)

   // LOCAL STATE HANDLER TO CALL IN PARENT COMPONENT
   useImperativeHandle(passedInRef, () => ({ open: () => setIsOpen(true), close: () => setIsOpen(false) }))

   // LOCAL COMPONENT CSS STYLE
   const contentStyleContainer = {
      margin: "1.5625rem 1.5625rem 0 1.5625rem",
   }
   const footerStyleContainer = {
      margin: "1.5625rem 1.5625rem 1.5625rem 0",
   }
   // =========================

   return (
      <Modal
         className={className}
         width={width}
         styles={{
            content: { maxHeight: "90vh", overflowY: "auto", borderRadius: "10px", ...contentStyle },
            body: { ...bodyStyle },
            mask: { ...maskStyle },
         }}
         zIndex={2000}
         centered
         title={title || false}
         footer={<div style={footerStyleContainer}>{footer}</div>}
         closeIcon={false}
         open={isOpen}
         maskClosable={preventCloseWhen ? false : true}
         destroyOnClose={true}
         keyboard={preventCloseWhen ? false : true}
         onCancel={() => setIsOpen(false)}
      >
         <div style={contentStyleContainer}>{children}</div>
      </Modal>
   )
}
